import http from '@/service/http'
import {ROOT_SIMULATOR} from './urlConfig'

//获取场景树状结构
export const getSceneTypeTree = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/sceneManage/getCourseTypeTree',params)
}

//根据用户ID和场景ID获取训练列表
export const getScores = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getScoresByUserIdAndType',params)
}

//获取训练成绩排行榜
export const getScoresRank = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getRankingsScores',params)
}

//获取用户成绩统计
export const getUserTrainingStatistics =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getUserTrainingStatistics',params)
}

//获取用户等级详情
export const getUserLevelDetail =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/userLevelDetail',params)
}
// 获取SceneSubType下拉列表
export const getSceneSubTypeDropdownList =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getSceneSubTypeDropdownList',params)
}
// 获取异常下拉列表
export const getMistakeTypeDropdownList =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getMistakeTypeDropdownList',params)
}
// 获取成绩分页查询
export const getTrainingDataByPage =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getTrainingDataByPage',params)
}
// 获取用户训练数据统计
export const getUserTrainingStatisticsByLimit =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getUserTrainingStatisticsByLimit',params)
}
// 获取当前用户在当前场景类型下的飞行经历总时长（秒）
export const getUserOverallFlyTime = (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getUserOverallFlyTime',params)
}
// 获取通关训练数据统计
export const getUserTestStatisticsByLimit =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getUserTestStatisticsByLimit',params)
}
// 获取异常统计
export const getMistakeStatisticsByLimit =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getMistakeStatisticsByLimit',params)
}
// 获取通关测试分页查询
export const getTestDataByPage =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getTestDataByPage',params)
}
// 获取新版训练成绩排行榜
export const getRankingsScoresBySceneTypeAndTenantId =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getRankingsScoresBySceneTypeAndTenantId',params)
}
// 获取训练详情
export const getSimulatorTrainingDetail =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getSimulatorTrainingDetail',params)
}
// 获取训练AI评价数据
export const getTrainingAiDataById =  (params:object)=>{
    return http.post(ROOT_SIMULATOR+'/api/training/getTrainingAiDataById',params)
}
